import React, { Fragment } from 'react';

function MenuIcon() {
  return (
    <Fragment>
      <svg width="35px" height="22px" className="hide-on-mobile" viewBox="0 0 35 22" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>Menu</title>
        <g fill="none" fillRule="evenodd">
          <g fill="#404040">
            <polygon points="0 12 35 12 35 10 0 10" />
            <polygon points="0 22 35 22 35 20 0 20" />
            <polygon points="0 2 35 2 35 0 0 0" />
          </g>
        </g>
      </svg>
      <svg version="1.1" className="show-on-mobile" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 29 18" enableBackground="new 0 0 29 18">
        <polygon fill="#404040" points="0,10 29,10 29,8 0,8     "/>
        <polygon fill="#404040" points="0,18 29,18 29,16 0,16     "/>
        <polygon fill="#404040" points="0,2 29,2 29,0 0,0     "/>
      </svg>
    </Fragment>
  );
}

export default MenuIcon;



// WEBPACK FOOTER //
// ./src/components/icons/MenuIcon.js